import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextContentRo = () => {
    return (
        <HighlightedText
            text="Ați câștigat 400 de rotiri gratuite"
            highlights={[{ word: '400' }]}
            breakAfterWords={['400']}
            className={styles.text_content}
        />
    )
}
